














import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import _ from "lodash";
import EventBus from "front-component/EventBus";

@Component({})
export default class WeekSearch extends Vue {
    @Prop({ type: Array, default: () => [] }) public value!: number[];
    @Prop() public filterName!: string;
    @Prop() public placeholder!: string;
    @Prop({ default: 500 }) public waitTime!: number;

    private filterValue: number[] = [];
    private debounceTimer: number | null = null;

    public mounted() {
        this.filterValue = this.value;
    }
    @Watch("value") private updateValue() {
        this.filterValue = this.value;
    }

    @Watch("filterValue") public onFilterChange(): void {
        if (this.debounceTimer) {
            clearTimeout(this.debounceTimer);
        }
        this.debounceTimer = window.setTimeout(() => {
            EventBus.$emit("update-filter", _.set({}, this.filterName, this.filterValue));
        }, this.waitTime);
    }
}
